import React, { useEffect } from 'react';

interface SEOUpdaterProps {
    title?: string;
    description?: string;
    headScript?: string;
    footerScript?: string;
}

const SEOUpdater: React.FC<SEOUpdaterProps> = ({ title, description, headScript, footerScript }) => {
    useEffect(() => {
        if (title) {
            document.title = title;
        }

        if (description) {
            let metaDescription = document.querySelector('meta[name="description"]');
            if (!metaDescription) {
                metaDescription = document.createElement('meta');
                metaDescription.setAttribute('name', 'description');
                document.head.appendChild(metaDescription);
            }
            metaDescription.setAttribute('content', description);
        }
    }, [title, description]);

    useEffect(() => {
        const injectedElements: HTMLElement[] = [];

        const processContent = (content: string, location: 'head' | 'body') => {
            if (!content || typeof content !== 'string') return;

            let remaining = content;

            // 1. Extrair e injetar blocos <style>...</style>
            const styleRegex = /<style[^>]*>([\s\S]*?)<\/style>/gi;
            let styleMatch;
            while ((styleMatch = styleRegex.exec(content)) !== null) {
                const cssContent = styleMatch[1].trim();
                if (cssContent) {
                    const styleEl = document.createElement('style');
                    styleEl.setAttribute('data-quiz-style', 'true');
                    styleEl.textContent = cssContent;
                    document.head.appendChild(styleEl);
                    injectedElements.push(styleEl);
                }
            }
            // Remover blocos <style> do conteúdo restante
            remaining = remaining.replace(styleRegex, '').trim();

            // 2. Limpar script tags e processar JS restante
            if (remaining) {
                let cleanContent = remaining
                    .replace(/<\/?script[^>]*>/gi, '')
                    .replace(/<!--[\s\S]*?-->/g, '')
                    .trim();

                // Pular se vazio ou se ainda contém HTML tags (segurança)
                if (!cleanContent || /<[a-zA-Z]/.test(cleanContent)) {
                    return;
                }

                try {
                    const script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.textContent = cleanContent;
                    script.setAttribute('data-quiz-script', 'true');

                    if (location === 'head') {
                        document.head.appendChild(script);
                    } else {
                        document.body.appendChild(script);
                    }
                    injectedElements.push(script);
                } catch (e) {
                    console.warn('SEOUpdater: Could not add script');
                }
            }
        };

        if (headScript) processContent(headScript, 'head');
        if (footerScript) processContent(footerScript, 'body');

        return () => {
            injectedElements.forEach(el => {
                if (el.parentNode) el.parentNode.removeChild(el);
            });
        };
    }, [headScript, footerScript]);

    return null;
};

export default SEOUpdater;
